function CustomTextArea({
  label,
  value,
  onChange,
  isRequired = true,
  optionalLabelText,
  placeholder,
  isError,
  errorMessage,
  ...props
}) {
  const optionalPlaceholder = optionalLabelText ? (isRequired ? '*' : ` (${optionalLabelText})`) : '';

  return (
    <div className="custom-textarea">
      {label && <label>{label}</label>}
      <textarea
        value={value || ''}
        onChange={onChange}
        placeholder={`${placeholder}${optionalPlaceholder}`}
        className={`form-control ${isError ? 'error-input' : ''}`}
        {...props}
      />
      {isError && errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  );
}

export default CustomTextArea;
